import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ceil, isEmpty } from "lodash";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from  '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { getRequisitionList as onGetRequisitionList, getDocument  as onGetDocument,
  setRequisition as OnSetRequisition, getDocumentAll as onGetDocuments,
getDocumentAllSuccess as onGetDocumentAllSuccess} from "../../store/requisitions/actions"

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  Col,
  Row,
  Card,
  CardBody,
} from "reactstrap";
import GenerateRequisitionModal from "pages/Invoices/GenerateRequisitionModal";
import PDFViewer from "../../components/Common/PDFViewer/PDFViewer"
import { useMemoRequisitionCols } from "./ColRequisitionMemo";

function RequisitionList() {

  const dispatch = useDispatch()
  
  const { requisitionList, activeTab, totalItems } = useSelector(state => ({
    requisitionList: state.Requisitions.requisitionList,
    activeTab: state.Requisitions.activeTab,
    totalItems: state.Requisitions.totalItems
  }));

  //meta title
  document.title = "Requisiciones | Platform";

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [viewDocShow, setViewDocShow] = useState(false);

  const [modalGenerateReqShow, setModalGenerateReqShow] = useState(false);

  const [invoices, setInvoices] = useState([]);
  const [order, setOrder] = useState(null);

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0
  });

  const handlePageChange = (newPage, newPageSize) => {
    setPagination(prev => ({
      ...prev,
      page: newPage,
      pageSize: newPageSize
    }));
  };

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: (order && order.orderId) || '',
      billingName: (order && order.billingName) || '',
      orderdate: (order && order.orderdate) || '',
      total: (order && order.total) || '',
      paymentStatus: (order && order.paymentStatus) || 'Paid',
      badgeclass: (order && order.badgeclass) || 'success',
      paymentMethod: (order && order.paymentMethod) || 'Mastercard',
    },
    validationSchema: Yup.object({
      orderId: Yup.string()
        .matches(
          /[0-9\.\-\s+\/()]+/,
          "Please Enter Valid Order Id"
        ).required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderdate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string().matches(
        /[0-9\.\-\s+\/()]+/,
        "Please Enter Valid Amount"
      ).required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeclass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateOrder = {
          id: order ? order.id : 0,
          orderId: values.orderId,
          billingName: values.billingName,
          orderdate: values.orderdate,
          total: values.total,
          paymentStatus: values.paymentStatus,
          paymentMethod: values.paymentMethod,
          badgeclass: values.badgeclass,
        };
        // update order
        dispatch(onUpdateOrder(updateOrder));
        validation.resetForm();
      } else {
        const newOrder = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          orderId: values["orderId"],
          billingName: values["billingName"],
          orderdate: values["orderdate"],
          total: values["total"],
          paymentStatus: values["paymentStatus"],
          paymentMethod: values["paymentMethod"],
          badgeclass: values["badgeclass"],
        };
        // save new order
        dispatch(onAddNewOrder(newOrder));
        validation.resetForm();
      }
      toggle();
    },
  });


  const toggleViewModal = () => setModal1(!modal1);
  const toggleGenerateRefModal = () => {
    let modalGenerateReqShowL = !modalGenerateReqShow
    setModalGenerateReqShow(modalGenerateReqShowL)
  };

  const toggleViewDocModal = () => {
    const viewDocShowL = !viewDocShow
    setViewDocShow(viewDocShowL);
    if(!viewDocShowL) {
      dispatch(onGetDocumentAllSuccess(null))
    }
  }

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };


  const [invoicesAdd, setInvoicesAdd] = useState([]);
    const handleGetDocumentDownload = (data,e) => {
        dispatch(onGetDocument(data))
      toggleViewDocModal()
    }
    const handleContinueRequisition = (requisitionL,e) => {
      e.preventDefault();
      dispatch(OnSetRequisition(requisitionL))
      setModalGenerateReqShow(!modalGenerateReqShow)
    }

  const handleGetDocumentAllDownload = (req) => {
    dispatch(onGetDocuments(req))
    toggleViewDocModal()
  }

  const columns = useMemoRequisitionCols(handleGetDocumentDownload, handleContinueRequisition, handleGetDocumentAllDownload);

  const [col, setCol] = useState(null);
  const [params, setParams] = useState(null);
  const handleGetReauisitionsRequest = (col=null, params=null) => {    
    setCol(col)
    setParams(params)
    dispatch(onGetRequisitionList({
      columnFilter: col?.id,
      param: params,
      page: pagination.page,
      pageSize: pagination.pageSize
    }));
  }

  useEffect(()=> {
    handleGetReauisitionsRequest(col, params);
  }, [pagination.page, pagination.pageSize]);


  useEffect(()=> {
    if(activeTab===5) {
      toggleGenerateRefModal()
    }
  }, [activeTab])
  return (
    <React.Fragment>
     
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Listado" breadcrumbItem="Requisisiones" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer onRemoteFilterChange={handleGetReauisitionsRequest}
                    columns={columns} 
                    data={requisitionList}
                    isGlobalFilter={true}
                    isAddOption={true}
                    handleOptionClick={toggleGenerateRefModal}
                    labelOption={"Generar Requisición"}
                    customPageSize={pagination.pageSize}
                    serverSidePagination={{
                      totalItems: totalItems,
                      currentPage: pagination.page,
                      onPageChange: handlePageChange
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <PDFViewer  isOpen={viewDocShow} toggle={toggleViewDocModal}/>

          <GenerateRequisitionModal pagination={pagination} invoicesAdd={invoicesAdd} isOpen={modalGenerateReqShow} toggle={toggleGenerateRefModal} />
        </div>
      </div>
    </React.Fragment>
  );
}
RequisitionList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default RequisitionList;